
import { SitemapService } from "@/services/sitemapService";

/**
 * Generate sitemap and return as downloadable blob
 */
export async function generateSitemapBlob(): Promise<Blob> {
  const sitemapService = new SitemapService();
  const xmlContent = await sitemapService.generateSitemap();
  
  return new Blob([xmlContent], { type: 'application/xml' });
}

/**
 * Download sitemap as XML file
 */
export async function downloadSitemap(): Promise<void> {
  try {
    const blob = await generateSitemapBlob();
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.download = 'sitemap.xml';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading sitemap:', error);
    throw error;
  }
}

/**
 * Validate sitemap XML structure
 */
export function validateSitemapXML(xmlContent: string): {
  isValid: boolean;
  errors: string[];
} {
  const errors: string[] = [];
  
  // Basic XML structure validation
  if (!xmlContent.includes('<?xml version="1.0" encoding="UTF-8"?>')) {
    errors.push('Missing XML declaration');
  }
  
  if (!xmlContent.includes('<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">')) {
    errors.push('Missing or invalid urlset element');
  }
  
  if (!xmlContent.includes('</urlset>')) {
    errors.push('Missing closing urlset tag');
  }
  
  // Check for required loc elements
  const urlElements = xmlContent.match(/<url>/g);
  const locElements = xmlContent.match(/<loc>/g);
  
  if (urlElements && locElements) {
    if (urlElements.length !== locElements.length) {
      errors.push('Each URL element must contain a loc element');
    }
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}
